<template>
  <div class="flex justify-center items-start sm:items-center h-screen w-screen p-4">
    <div class="px-8 py-6 rounded-lg bg-main-100 w-full sm:max-w-2xl mb-4">
      <div class="flex flex-row justify-between items-center mb-4">
        <h1 class="text-4xl sm:text-5xl font-header w-full text-white">
          <img :src="`${publicPath}logo.png`" class="w-10 h-10 mr-2 inline-block"> CodeNames
        </h1>
      </div>
      <p class="text-gray-200">A multiplayer game where you uncover cryptic agents names in two teams. Cooperation is a key to success.</p>
      <div class="flex flex-nowrap items-center rounded-lg bg-main-200 mx-0 sm:mx-16 mt-6 my-2 pr-1">
        <span class="text-white bg-main-300 p-4 py-3 rounded-l-lg">Name:</span>
        <input type="text" v-model="name" ref="nameField" class="border-0 py-2 px-3 text-white w-full focus:outline-none bg-transparent" maxlength="16" minlength="2" placeholder="Your pseudo">
        <button @click="randomName()" title="Random name" class="focus:outline-none rounded-lg bg-main-300 hover:bg-main-100 text-white text-xl w-14 h-10 flex items-center justify-center mr-0.5">
          <i class="fas fa-dice-three"></i>
        </button>
      </div>
      <span class="text-sm text-warning-400 px-0 sm:px-16" v-show="nameError">Your name can't be empty</span>
      <div class="flex w-full justify-between flex-col sm:flex-row text-white mt-6">
        <div class="w-full sm:w-1/2 sm:pr-4 border-main-300 sm:border-r">
          <h2 class="text-lg font-bold my-1">Create New Room</h2>
          <p class="text-sm text-gray-200 pb-2">Start a new game and give the unique room code to your friends to play together.</p>
          <button @click="createRoom()" title="Random name" class="focus:outline-none rounded-lg bg-team-red hover:bg-team-hover-red text-white text-lg h-12 w-full px-4 pr-6 flex items-center justify-center mt-2 my-4">
            <i class="fas fa-plus mr-4"></i> New game
          </button>
        </div>
        <div class="w-full sm:w-1/2 sm:pl-4">
          <h2 class="text-lg font-bold my-1">Join Existing Room</h2>
          <p class="text-sm text-gray-200 pb-2">If you got a room code from someone enter it in the field below to join the game.</p>
          <div class="flex flex-nowrap items-center rounded-lg bg-main-200 my-2 pr-1">
            <span class="text-white bg-main-300 p-4 py-3 rounded-l-lg"><i class="fas fa-hashtag"></i></span>
            <input type="text" v-model="roomCode" ref="nameField" class="border-0 py-2 px-3 text-white w-full focus:outline-none bg-transparent" maxlength="8" minlength="8" placeholder="########">
            <button @click="joinRoom()" title="Random name" class="focus:outline-none rounded-lg bg-team-blue hover:bg-team-hover-blue text-white text-lg px-4 h-10 flex items-center justify-center mr-0.5">
              <i class="fas fa-arrow-right mr-3"></i> Join
            </button>
          </div>
          <span class="text-sm text-warning-400 leading-2" v-show="roomCodeError">The room code is incorrent</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lobby',
  data() {
	  return {
      publicPath: process.env.BASE_URL,
      name: '',
      nameError: false,
      roomCode: '',
      roomCodeError: false,
      nameList: [
        "acre",
        "acne",
        "addendum",
        "aircraft",
        "aisle",
        "america",
        "ankle",
        "apathy",
        "applause",
        "arm",
        "armada",
        "asleep",
        "athlete",
        "atlantis",
        "aunt",
        "avocado",
        "backbone",
        "bag",
        "baguette",
        "bald",
        "balloon",
        "banana",
        "banister",
        "baseball",
        "bat",
        "battery",
        "beach",
        "bedbug",
        "beer",
        "belt",
        "bib",
        "bicycle",
        "big",
        "bike",
        "bird",
        "birthday",
        "bite",
        "blanket",
        "bleach",
        "blimp",
        "blossom",
        "blunt",
        "blur",
        "boa",
        "boat",
        "bob",
        "bobsled",
        "body",
        "bomb",
        "bonnet",
        "book",
        "booth",
        "bowtie",
        "box",
        "boy",
        "brand",
        "brave",
        "bride",
        "bridge",
        "broccoli",
        "broken",
        "broom",
        "bruise",
        "brunette",
        "bubble",
        "buddy",
        "buffalo",
        "bulb",
        "bunny",
        "bus",
        "buy",
        "cabin",
        "cake",
        "campsite",
        "can",
        "canada",
        "candle",
        "candy",
        "cape",
        "car",
        "cat",
        "cd",
        "ceiling",
        "cell",
        "century",
        "chair",
        "chalk",
        "champion",
        "charger",
        "chef",
        "chess",
        "chew",
        "chicken",
        "chime",
        "china",
        "church",
        "circus",
        "clay",
        "cliff",
        "cloak",
        "clown",
        "clue",
        "coach",
        "coal",
        "coaster",
        "cog",
        "cold",
        "college",
        "comfort",
        "computer",
        "cone",
        "cook",
        "coop",
        "cord",
        "corduroy",
        "cot",
        "cough",
        "cow",
        "cowboy",
        "crayon",
        "cream",
        "crisp",
        "crow",
        "cruise",
        "crumb",
        "crust",
        "cuff",
        "curtain",
        "cuticle",
        "czar",
        "dad",
        "dart",
        "dawn",
        "day",
        "deep",
        "defect",
        "dent",
        "dentist",
        "desk",
        "dimple",
        "dirty",
        "ditch",
        "diver",
        "doctor",
        "dog",
        "doghouse",
        "doll",
        "dominoes",
        "door",
        "dot",
        "drain",
        "draw",
        "dream",
        "dress",
        "drink",
        "drip",
        "drums",
        "dryer",
        "duck",
        "dump",
        "dunk",
        "dust",
        "ear",
        "eat",
        "ebony",
        "elbow",
        "elephant",
        "elevator",
        "elf",
        "elm",
        "engine",
        "england",
        "eureka",
        "europe",
        "eyebrow",
        "fan",
        "fancy",
        "fast",
        "feast",
        "fence",
        "fiddle",
        "figment",
        "finger",
        "fire",
        "first",
        "fishing",
        "fix",
        "fizz",
        "flagpole",
        "flannel",
        "flock",
        "flotsam",
        "flower",
        "flu",
        "flush",
        "flutter",
        "fog",
        "foil",
        "football",
        "forehead",
        "forever",
        "france",
        "freckle",
        "freight",
        "fringe",
        "frog",
        "frown",
        "gallop",
        "game",
        "garbage",
        "garden",
        "gasoline",
        "gem",
        "ginger",
        "girl",
        "glasses",
        "goblin",
        "gold",
        "goodbye",
        "grandpa",
        "grape",
        "grass",
        "gray",
        "green",
        "guitar",
        "gum",
        "gumball",
        "hair",
        "half",
        "handle",
        "hang",
        "happy",
        "hat",
        "hatch",
        "headache",
        "heart",
        "hedge",
        "hem",
        "hide",
        "hill",
        "hockey",
        "homework",
        "honk",
        "horse",
        "hose",
        "hot",
        "house",
        "hug",
        "hungry",
        "hurdle",
        "hurt",
        "hut",
        "ice",
        "implode",
        "inn",
        "intern",
        "internet",
        "ironic",
        "ivory",
        "ivy",
        "jade",
        "japan",
        "jeans",
        "jelly",
        "jet",
        "jig",
        "jog",
        "journal",
        "jump",
        "key",
        "killer",
        "kilogram",
        "king",
        "kitchen",
        "kite",
        "knee",
        "kneel",
        "knife",
        "knight",
        "koala",
        "lace",
        "ladder",
        "ladybug",
        "lag",
        "landfill",
        "lap",
        "laugh",
        "laundry",
        "law",
        "lawn",
        "leak",
        "leg",
        "letter",
        "level",
        "ligament",
        "light",
        "lime",
        "lion",
        "lizard",
        "log",
        "loiterer",
        "lollipop",
        "loveseat",
        "loyalty",
        "lunch",
        "lunchbox",
        "lyrics",
        "machine",
        "macho",
        "mailbox",
        "mammoth",
        "mark",
        "mars",
        "mascot",
        "mast",
        "mate",
        "mattress",
        "mess",
        "mexico",
        "mine",
        "mistake",
        "modern",
        "mold",
        "mom",
        "monday",
        "money",
        "monitor",
        "monster",
        "mooch",
        "moon",
        "mop",
        "moth",
        "mountain",
        "mouse",
        "mower",
        "mud",
        "music",
        "mute",
        "nature",
        "neighbor",
        "nest",
        "neutron",
        "niece",
        "night",
        "nose",
        "oar",
        "office",
        "oil",
        "old",
        "olympian",
        "opaque",
        "opener",
        "orbit",
        "organ",
        "organize",
        "outer",
        "outside",
        "ovation",
        "overture",
        "pail",
        "paint",
        "pajamas",
        "palace",
        "pants",
        "paper",
        "paper",
        "park",
        "parody",
        "party",
        "password",
        "pastry",
        "pawn",
        "pear",
        "pen",
        "pencil",
        "pendulum",
        "penis",
        "penny",
        "pepper",
        "personal",
        "phone",
        "piano",
        "picnic",
        "pigpen",
        "pillow",
        "pilot",
        "pinch",
        "ping",
        "pinwheel",
        "pirate",
        "plaid",
        "plan",
        "plank",
        "plate",
        "platypus",
        "plow",
        "plumber",
        "pocket",
        "poem",
        "point",
        "pole",
        "pomp",
        "pong",
        "pool",
        "popsicle",
        "positive",
        "post",
        "princess",
        "punk",
        "puppet",
        "puppy",
        "push",
        "puzzle",
        "queen",
        "quiet",
        "race",
        "radio",
        "raft",
        "rag",
        "rainbow",
        "random",
        "ray",
        "recycle",
        "red",
        "regret",
        "rib",
        "riddle",
        "rim",
        "rink",
        "roller",
        "room",
        "rose",
        "round",
        "rung",
        "runt",
        "rut",
        "sad",
        "safe",
        "salmon",
        "salt",
        "sandbox",
        "sandwich",
        "sash",
        "scar",
        "scared",
        "school",
        "scramble",
        "scuff",
        "seashell",
        "season",
        "sentence",
        "sequins",
        "set",
        "shaft",
        "shallow",
        "shampoo",
        "shark",
        "sheep",
        "sheets",
        "sheriff",
        "shirt",
        "shoelace",
        "short",
        "shower",
        "shrink",
        "sick",
        "siesta",
        "singer",
        "sip",
        "skate",
        "skating",
        "ski",
        "slam",
        "sleep",
        "sling",
        "slow",
        "slump",
        "smith",
        "sneeze",
        "snow",
        "snuggle",
        "song",
        "space",
        "spare",
        "speakers",
        "spider",
        "spit",
        "sponge",
        "spool",
        "spoon",
        "spring",
        "spy",
        "square",
        "squint",
        "stairs",
        "standing",
        "star",
        "state",
        "stick",
        "stout",
        "stove",
        "stowaway",
        "straw",
        "stream",
        "stripe",
        "student",
        "sun",
        "sunburn",
        "sushi",
        "swamp",
        "swarm",
        "sweater",
        "swimming",
        "swing",
        "talk",
        "taxi",
        "teacher",
        "teapot",
        "teenager",
        "ten",
        "tennis",
        "thief",
        "think",
        "throne",
        "through",
        "thunder",
        "tide",
        "tiger",
        "time",
        "tinting",
        "tiptoe",
        "tiptop",
        "tired",
        "tissue",
        "toast",
        "toilet",
        "tool",
        "tornado",
        "tractor",
        "train",
        "trash",
        "treasure",
        "tree",
        "triangle",
        "trip",
        "truck",
        "tub",
        "tuba",
        "tutor",
        "twang",
        "twig",
        "type",
        "upgrade",
        "vest",
        "vision",
        "wag",
        "water",
        "wax",
        "wedding",
        "weed",
        "welder",
        "whatever",
        "whiplash",
        "whisk",
        "whistle",
        "white",
        "wig",
        "will",
        "windmill",
        "winter",
        "wish",
        "wolf",
        "wool",
        "world",
        "worm",
        "zamboni",
        "zen",
        "zero",
        "zipper",
        "zone",
        "zoo"
      ]
	  }
  },
  mounted() {
    if (localStorage.name) {
      this.name = localStorage.name;
    }
  },
  watch: {
    name: function(val) {
      this.nameError = false;
      localStorage.name = val;
    },
    roomCode: function(val) {
      this.roomCodeError = false;
    },
  },
  methods: {
    randomName() {
      const randomPick = this.nameList[Math.floor(Math.random() * this.nameList.length)];
      this.name = 'Agent ' + randomPick[0].toUpperCase() + randomPick.slice(1);
      localStorage.name = this.name;
    },
    validateName() {
      return this.nameError = this.name.length == 0;
    },
    validateRoomCode() {
      return this.roomCodeError = this.roomCode.length != 8;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0, 
        left: 0, 
        behavior: 'smooth'
      });
    },
    joinRoom() {
      this.validateRoomCode();
      if(!this.validateName() && !this.validateRoomCode()) {
        this.$emit('join-room', { name: this.name, roomCode: this.roomCode });
        this.scrollToTop();
      }
    },
    createRoom() {
      this.roomCodeError = false;
      if(!this.validateName()) {
        this.$emit('create-room', { name: this.name });
        this.scrollToTop();
      }
    }
  },
  emits: ['join-room', 'create-room']
}
</script>